import { render, staticRenderFns } from "./CompanyTranslation.vue?vue&type=template&id=87ada5bc&scoped=true"
import script from "./CompanyTranslation.vue?vue&type=script&lang=js"
export * from "./CompanyTranslation.vue?vue&type=script&lang=js"
import style0 from "./CompanyTranslation.vue?vue&type=style&index=0&id=87ada5bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ada5bc",
  null
  
)

export default component.exports